export default function dayNightReducer(dayNight, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...dayNight, [action.type]: action.value ? Number(action.value).toString() : "" };

    default:
      return { ...dayNight, [action.type]: action.value };
  }
}
